"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataHub = exports.DataHubContract = void 0;
const ethers_1 = require("ethers");
const DataHub_json_1 = __importDefault(require("../contracts/DataHub/DataHub.json"));
const model_1 = require("../model");
const constants_1 = require("../constants");
const tx_1 = require("../utils/tx");
const utils_1 = require("ethers/lib/utils");
exports.DataHubContract = DataHub_json_1.default;
class DataHub {
    constructor(config = constants_1.DATA_HUB_ENVIRONMENT_CONFIGS[model_1.Environments.LOCALHOST], signerOrProvider = null, domain = constants_1.ENS_DOMAIN, connectionConfig) {
        this.domain = domain;
        this._provider = new ethers_1.providers.JsonRpcProvider(connectionConfig || config.rpcUrl);
        this._dataHubContract = new ethers_1.Contract(config.dataHubAddress, exports.DataHubContract.abi, this._provider);
        if (signerOrProvider) {
            this.connect(signerOrProvider);
        }
    }
    /**
     * returns RPC provider
     */
    get provider() {
        return this._provider;
    }
    /**
     * Connects signer to the smart contract
     * @param signerOrProvider An instance of ethers.js Wallet or any other signer
     */
    connect(signerOrProvider) {
        this._dataHubContract = this._dataHubContract.connect(signerOrProvider);
    }
    createSubscription(ens, location, price, categoryHash, podAddress, daysValid, value) {
        return (0, tx_1.waitTransaction)(this._dataHubContract.listSub(this.hashUsername(ens), location, price, categoryHash, podAddress, daysValid, { value }));
    }
    getUsersSubscriptions(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const subscriptionIds = yield this._dataHubContract.getListedSubs(address);
            const subscriptions = [];
            yield subscriptionIds.reduce((prevRequest, subscriptionId) => __awaiter(this, void 0, void 0, function* () {
                yield prevRequest;
                const subscription = yield this._dataHubContract.getSubBy(subscriptionId);
                subscriptions.push(subscription);
            }), Promise.resolve());
            return subscriptions;
        });
    }
    requestSubscription(subHash, buyerUsername, price) {
        return (0, tx_1.waitTransaction)(this._dataHubContract.bidSub(subHash, this.hashUsername(buyerUsername), { value: price }));
    }
    requestSubscriptionAgain(requestHash, price) {
        return (0, tx_1.waitTransaction)(this._dataHubContract.requestAgain(requestHash, { value: price }));
    }
    removeUserActiveBid(requestHash) {
        return (0, tx_1.waitTransaction)(this._dataHubContract.removeUserActiveBid(requestHash));
    }
    sellSubscription(requestHash, encryptedKeyLocation) {
        return (0, tx_1.waitTransaction)(this._dataHubContract.sellSub(requestHash, encryptedKeyLocation));
    }
    getUserStats(address) {
        return this._dataHubContract.getUserStats(address);
    }
    setPortableAddress(address) {
        return (0, tx_1.waitTransaction)(this._dataHubContract.setPortableAddress(address));
    }
    getPortableAddress(address) {
        return this._dataHubContract.getPortableAddress(address);
    }
    getFee(fee, amount) {
        return this._dataHubContract.getFee(fee, amount);
    }
    setFee(newFee) {
        return (0, tx_1.waitTransaction)(this._dataHubContract.setFee(newFee));
    }
    setListingFee(newListingFee) {
        return (0, tx_1.waitTransaction)(this._dataHubContract.setListingFee(newListingFee));
    }
    getCategory(category) {
        return this._dataHubContract.getCategory(category);
    }
    getSubs() {
        return this._dataHubContract.getSubs();
    }
    getSubByIndex(index) {
        return this._dataHubContract.getSubByIndex(index);
    }
    getSubBy(subHash) {
        return this._dataHubContract.getSubBy(subHash);
    }
    getSubRequestAt(address, index) {
        return this._dataHubContract.getSubRequestAt(address, index);
    }
    getActiveBidAt(address, index) {
        return this._dataHubContract.getActiveBidAt(address, index);
    }
    getAllSubItems(address) {
        return this._dataHubContract.getAllSubItems(address);
    }
    getAllSubItemsForNameHash(nameHash) {
        return this._dataHubContract.getAllSubItemsForNameHash(nameHash);
    }
    getNameHashSubItems(nameHash) {
        return this._dataHubContract.getNameHashSubItems(nameHash);
    }
    getListedSubs(address) {
        return this._dataHubContract.getListedSubs(address);
    }
    getActiveBids(address) {
        return this._dataHubContract.getActiveBids(address);
    }
    getSubRequestByHash(address, requestHash) {
        return this._dataHubContract.getSubRequestByHash(address, requestHash);
    }
    getActiveBidsByHash(address, requestHash) {
        return this._dataHubContract.getActiveBidsByHash(address, requestHash);
    }
    getSubRequests(address) {
        return this._dataHubContract.getSubRequests(address);
    }
    getSubSubscribers(subHash) {
        return this._dataHubContract.getSubSubscribers(subHash);
    }
    getSubInfoBalance(subHash, address) {
        return this._dataHubContract.getSubInfoBalance(subHash, address);
    }
    enableSub(subHash, active) {
        return (0, tx_1.waitTransaction)(this._dataHubContract.enableSub(subHash, active));
    }
    reportSub(subHash) {
        return (0, tx_1.waitTransaction)(this._dataHubContract.reportSub(subHash));
    }
    hashUsername(username) {
        return (0, utils_1.namehash)(`${username}.${this.domain}`);
    }
}
exports.DataHub = DataHub;
